export const NO_IMAGE_PLACEHOLDER =
  "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0aHBwgJC4nICIsIxwcKDcpLDAxNDQ0Hyc5PTgyPC4zNDL/2wBDAQkJCQwLDBgNDRgyIRwhMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjL/wAARCAIjAiMDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAX/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCdABmX/9k=";

export const VEHICLE_CATEGORIES = [
  "Hatchback",
  "SUV",
  "Sedan",
  "MPV",
  "MUV",
  "Commercial",
];

export const ENGINE_TYPES = ["ICE", "Electric", "Hybrid"];

export const IMAGE_TYPES = ["Colors", "Interior", "Exterior", "Other"];

export const VEHICLE_STATUSES = ["Active", "Discontinued"];
